import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import _ from "lodash";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../shared/CustomButton";
import AppButton from "../../../../shared/AppButton";
import CustomFilterInput from "../../../../shared/CustomFilterInput";
import { FaFilter, FaUndo } from "react-icons/fa";

function FilterModal({ refetch, setPageNo, setLimit, pageNo, setIsLoading }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const beneficiariesPageNo = JSON.parse(
    localStorage.getItem("beneficiariesPageNo"),
  );

  useEffect(() => {
    if (location?.pathname === "/beneficiary") {
      localStorage.setItem(
        "beneficiariesPageNo",
        JSON.stringify(pageNo ? pageNo : 1),
      );
    }
  }, [location?.pathname, pageNo]);

  const addData = async (values) => {
    let data = _.cloneDeep(values);
    setPageNo(1);
    let obj = {
      full_name: values.name,
      file_no: values.fileID,
      providers_id: values.providerId,
      document_id: values.documentID,
      contact_number: values.contact,
      limit: 10,
      page: 1,
    };
    setIsLoading(true);
    await refetch({
      filters: Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
    setIsLoading(false);
    delete obj.limit;
    delete obj.page;
  };

  const handleResetForm = async () => {
    setPageNo(1);
    let obj = {
      full_name: "",
      file_no: "",
      providers_id: "",
      document_id: "",
      contact_number: "",
      limit: 10,
      page: 1,
    };
    setIsLoading(true);
    await refetch({
      filters: Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
    setIsLoading(false);

    delete obj.limit;
    delete obj.page;
  };

  return (
    <div className="flex items-center">
      <Formik
        initialValues={{
          name: "",
          documentID: "",
          contact: "",
          fileID: "",
          memberCardID: "",
          providerId: "",
        }}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={(values, { setSubmitting }) => {
          addData(values);
        }}
        onReset={handleResetForm}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          resetForm,
          /* and other goodies */
        }) => (
          <div className="w-full ">
            <div className="w-full flex flex-col sm:flex-row gap-x-1.5 gap-y-1.5 justify-end">
              <CustomFilterInput
                label={t("Name")}
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={t("Name")}
                id="name"
              />
              <CustomFilterInput
                label={t("Document ID")}
                name="documentID"
                value={values.documentID}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={t("Document ID")}
                id="documentID"
              />
              <CustomFilterInput
                label={t("Contact")}
                name="contact"
                value={values.contact}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={t("Contact")}
                id="contact"
              />
              <CustomFilterInput
                label={t("File ID")}
                name="fileID"
                value={values.fileID}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={t("File ID")}
                id="fileID"
              />
              <div className="flex  gap-2 mt-[19px]">
                <AppButton
                  title={t("Reset")}
                  variant="reset"
                  className="!bg-slate-200"
                  onClick={resetForm}
                  startIcon={<FaUndo className="!text-[12px] " />}
                />
                <AppButton
                  title={t("Apply Filter")}
                  onClick={() => {
                    handleSubmit();
                  }}
                  startIcon={<FaFilter className="!text-[12px]" />}
                />
              </div>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default FilterModal;
